import { render, staticRenderFns } from "./tr.vue?vue&type=template&id=3a5c8121&"
import script from "./tr.vue?vue&type=script&lang=ts&"
export * from "./tr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports